import request from "@/utils/request";

export function queryAmountList(data) {
  return request({
    url: "/mgr/amountsManage/queryAmountList",
    method: "post",
    data,
  });
}

export function createAmount(data) {
  return request({
    url: "/mgr/amountsManage/createAmount",
    method: "post",
    data,
  });
}

export function updateAmount(data) {
  return request({
    url: "/mgr/amountsManage/updateAmount",
    method: "post",
    data,
  });
}

export function deleteAmount(data) {
  return request({
    url: "/mgr/amountsManage/deleteAmount",
    method: "post",
    data,
  });
}
